import menu from './menu'

export default {
  type: 'admin',
  routes: [...menu],
}
